import React from "react";
import "./Card.css";

export const Products = ({ products }) => {
  if (!products || products.length === 0) return null;

  return (
    <div className="products-grid">
      {products.map((item, i) => {
        const price = parseFloat(item.price) || 0;
        const originalPrice = parseFloat(item.originalPrice) || 0;
        const hasDiscount = originalPrice > price && price > 0;
        const pctOff = hasDiscount ? Math.round((1 - price / originalPrice) * 100) : 0;

        return (
          <a
            href={item.productUrl}
            target="_blank"
            rel="noreferrer"
            className="product-card"
            key={`${item.productUrl}-${i}`}
          >
            <div className="product-img-wrap">
              <img src={item.imageUrl} alt={item.brand} className="product-image" />
              {hasDiscount && (
                <span className="product-badge">{pctOff}% OFF</span>
              )}
            </div>
            <div className="product-info">
              <span className="product-brand">{item.brand}</span>
              <div className="product-meta">
                {item.sizes && item.sizes.length > 0 ? (
                  item.sizes.map(s => <span className="product-size" key={s}>{s}</span>)
                ) : (
                  item.size && <span className="product-size">{item.size}</span>
                )}
                {item.color && <span className="product-color">{item.color}</span>}
              </div>
              <div className="product-pricing">
                <span className="product-price">${price.toFixed(2)}</span>
                {hasDiscount && (
                  <span className="product-original">${originalPrice.toFixed(2)}</span>
                )}
              </div>
            </div>
          </a>
        );
      })}
    </div>
  );
};
